import React from 'react';
import HideButton from "./HideButton";
import PropTypes from "prop-types";

export default function RemoveItemsRow({items, hideItem}) {
  if (items.length <= 1)
    return null;

  return (
    <tr>
      <th className=""></th>
      {items.map((item, i) => <td className="text-center border-0 p-4" key={item.id}>
        <HideButton item={item} hideItem={hideItem}/></td>)}
    </tr>
  );
}

RemoveItemsRow.propTypes = {
  items: PropTypes.array.isRequired,
  hideItem: PropTypes.func.isRequired
}
